import { HostingDisplayName } from '@atlassian/mpac-types';
import { SectionHeading } from '@atlassian/mpac-ui';
import React from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
const PricingHeading = _ref => {
  let {
    hosting
  } = _ref;
  return /*#__PURE__*/_jsxs(SectionHeading, {
    children: [HostingDisplayName[hosting], " Pricing"]
  });
};
export default PricingHeading;